export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '楚天装饰工程',

    /** 公司名称 */
    name: '咸阳楚天装饰工程有限公司',
    /** 公司微信 */
    wechat: 'GZWjhsmart',
    /** 公司邮箱 */
    email: 'wjhsmarter@126.com',
    /** 公司手机 */
    phone: '18112345678',
    /** 公司电话 */
    tel: '18112345678',
    /** 公司地址 */
    address: '',
    /** 备案号 */
    keepOnRecordIcp: '沪ICP备xxxx号',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 121.526896,
        latitude: 31.24022,
        title: '普联大厦',
        address: ''
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js